import { useEffect, useState } from "react";
import { formatCountdown } from "./utils/string";

const TARGET_START = new Date("2026-10-23T09:00:00-07:00").getTime();
const TARGET_END = new Date("2026-10-23T10:00:00-07:00").getTime();

export function Banner() {
  const [message, setMessage] = useState("");
  const [link, setLink] = useState("http://go/bonfire");

  const prettyLink = link.replace("http://", "");

  useEffect(() => {
    const tick = () => {
      const now = Date.now();
      const startDelta = TARGET_START - now;
      const endDelta = TARGET_END - now;

      // event is over
      if (startDelta <= 0 && endDelta <= 0) {
        setMessage("See you next time!");
        setLink("http://go/bonfire");
        return;
      }

      // we're in the event right now
      if (startDelta <= 0) {
        setMessage("Bonfire is on now! Tune in!");
        setLink("http://go/stripetv/live");
        return;
      }

      const days = Math.floor(startDelta / 86_400_000);
      const hours = Math.floor((startDelta % 86_400_000) / 3_600_000);
      const minutes = Math.floor((startDelta % 3_600_000) / 60_000);
      const seconds = Math.floor((startDelta % 60_000) / 1000);
      setMessage(formatCountdown({ days, hours, minutes, seconds }));
    };

    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="Banner">
      <div className="Banner__logo">
        <img src="/logo.png" alt="Stripe Bonfire" />
      </div>

      <div className="Banner__container">
        <h2 className="Banner__countdown">{message}</h2>
        <p>
          <a href={link} target="_blank">
            {prettyLink}
          </a>
        </p>
      </div>
    </div>
  );
}
